'use strict';

/**
 * Detects devices and adds "is-device" classes to html element
 */
export default function() {
	const detectDevices = {
		desktop: () => window.matchMedia('(min-width: 1210px)').matches,
		android: () => /Android/i.test(navigator.userAgent),
		iOS: () => /iPhone|iPad|iPod/i.test(navigator.userAgent)
	}

	for (let name in detectDevices) {
		if (detectDevices[name]()) {
			document.documentElement.classList.add(`is-device-${name}`.toLowerCase());
		}
	}
}